import {DateObject} from '../../index';
import {Currency} from '../../reusables/currency';
import {InvoiceOrderStatusTranslationsService} from 'src/app/shared/translations';

/**
 * Blueprint for the order details part of ticketing object.
 */
export class TicketingOrderDetails {
  public orderNumber: string;
  public invoiceDate: DateObject;
  public invoiceNumber: string;
  public externalInvoiceNumber: string;
  public cancellationNumber: string;
  public paymentType: string;
  public branch: string;
  public shippingAmount: string;
  public shippingType: string;
  public shippingDate: string;
  public totalAmount: string;
  public currency: string;

  public paymentDetails: Currency;
  public shippingDetails: Currency;

  public statuses: Array<any> = [
    {
      value: 'CASH',
      status: this.translations.i18nCash
    },
    {
      value: 'CREDIT-CARD',
      status: this.translations.i18nCreditCard
    },
    {
      value: 'PAYPAL',
      status: this.translations.i18nPaypal
    },
    {
      value: '0',
      status: this.translations.i18nNoShipping
    },
    {
      value: 'OPTION',
      status: this.translations.i18nOption
    },
    {
      value: 'CHEQUE',
      status: this.translations.i18nCheque
    },
    {
      value: 'INVOICE',
      status: this.translations.i18nInvoice
    },
    {
      value: 'TRANSFER',
      status: this.translations.i18nTransfer
    },
    {
      value: 'CASHONDELIVERY',
      status: this.translations.i18nCashOnDelivery
    },
    {
      value: 'CASHCARD',
      status: this.translations.i18nCashCard
    },
    {
      value: 'CREDIT',
      status: this.translations.i18nCredit
    },
    {
      value: 'DOOR',
      status: this.translations.i18nDoor
    },
    {
      value: 'FREE1',
      status: this.translations.i18nFree1
    },
    {
      value: 'FREE2',
      status: this.translations.i18nFree2
    },
    {
      value: 'VOUCHER',
      status: this.translations.i18nVoucher
    },
    {
      value: 'SEPA',
      status: this.translations.i18nSepaDirectDebit
    },
    {
      value: 'CREDITCARD',
      status: this.translations.i18nCreditCard
    }
  ];

  constructor(data: any, private translations: InvoiceOrderStatusTranslationsService) {
    this.orderNumber = data.orderNumber;
    this.branch = data.branch;
    this.invoiceDate = new DateObject(data.invoiceDate, 'dd.MM.yyyy HH:mm');
    this.invoiceNumber = data.invoiceNumber;
    this.externalInvoiceNumber = data.externalInvoiceNumber;
    this.cancellationNumber = data.cancellationNumber;
    this.paymentType = data.paymentType;
    this.shippingType = data.shippingType;
    this.shippingDate = data.shippingDate || false;

    this.paymentDetails = new Currency(data.totalAmount, data.currency);
    this.shippingDetails = new Currency(data.shippingAmount, data.currency);
  }

  get displayInvoiceNumber(): string {
    if (this.cancellationNumber) {
      return this.externalInvoiceNumber ? this.externalInvoiceNumber : this.cancellationNumber;
    } else {
      return this.externalInvoiceNumber ? this.externalInvoiceNumber : this.invoiceNumber;
    }
  }

  /**
   * This function will translate the payment type
   */
  public get translatedPaymentType(): string {
    const translatedPaymentType = this.statuses.find(status => this.paymentType === status.value);
    return translatedPaymentType ? translatedPaymentType.status : this.paymentType;
  }

  /**
   * This function will translate the shipping type
   */
  public get translatedShippingType(): string | string {
    const translatedShippingType = this.statuses.find(status => this.shippingType === status.value);
    return translatedShippingType ? translatedShippingType.status : this.shippingType;
  }

}
